
import api from "@/services/api"
import { RecordNameSettings } from "@/types/recordNameSettings"

class ApiRecordNameSettings {
	private get axios () { return api.getAxios() }

	public async recordNameSettingsList (): Promise<RecordNameSettings[]> { return (await this.axios.get("/recordNameSettings")).data }
	public async recordNameSettingsSave (recordNameSettings: RecordNameSettings): Promise<string> { return (await this.axios.post("/recordNameSettings", recordNameSettings)).data }
	public async recordNameSettingsDelete (recordNameSettings: RecordNameSettings): Promise<void> { await this.axios.delete(`/recordNameSettings/${recordNameSettings.id}`) }
	public async recordNameSettingsDefault (recordNameSettings: RecordNameSettings): Promise<void> { await this.axios.put(`/recordNameSettings/default/${recordNameSettings.id}`) }
}

const apiRecordNameSettings = new ApiRecordNameSettings()
export default apiRecordNameSettings
